import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import {
  Button,
  Toolbar,
} from 'react-md';
import cn from 'classnames';

import { customEventPropGetter } from '../Calendar';
import JourneyValue from './JourneyValue';

const JourneyToolbar = ({
  intl,
  journey,
  journey: {
    startDateTime, endDateTime, stats: { avg, max }, decodedFields,
  },
  journeyIndex,
  journeysSize,
  handleOnHide,
  handleClickOnPreviousJourney,
  handleClickOnNextJourney,
}) => {
  const actions = [
    <JourneyValue
      title={intl.formatMessage({ id: 'journeyDetails.parameter.start' })}
      value={startDateTime}
      formatFunction={intl.formatTime}
    />,
    <JourneyValue
      title={intl.formatMessage({ id: 'journeyDetails.parameter.end' })}
      value={endDateTime}
      formatFunction={intl.formatTime}
    />,
    <JourneyValue
      title={intl.formatMessage({ id: 'journeyDetails.parameter.distance' })}
      value={(decodedFields || {}).MDI_ODO_JOURNEY}
      units="km"
      formatFunction={intl.formatNumber}
    />,
    <JourneyValue
      title={intl.formatMessage({ id: 'journeyDetails.parameter.avgSpeed' })}
      value={avg}
      formatFunction={n => intl.formatNumber(Math.round(n))}
      units="km/h"
    />,
    <JourneyValue
      title={intl.formatMessage({ id: 'journeyDetails.parameter.maxSpeed' })}
      value={max}
      formatFunction={n => intl.formatNumber(Math.round(n))}
      units="km/h"
    />,
  ];

  return (
    <Toolbar
      fixed
      colored
      singleColor
      className={cn('journeyToolbar', customEventPropGetter(journey).className)}
      title={
        <div>
          <h2>
            {intl.formatDate(startDateTime, {
          month: 'long',
          day: 'numeric',
        })}
          </h2>
          <h4>{intl.formatMessage({ id: 'journeyDetails.indexTitle' }, { index: journeyIndex + 1, total: journeysSize })}</h4>
        </div>}
      titleId="simple-full-page-dialog-title"
      nav={
        <span>
          <Button icon onClick={handleOnHide}>close</Button>
          <Button icon onClick={handleClickOnPreviousJourney} disabled={journeyIndex === 0}>chevron_left</Button>
          <Button icon onClick={handleClickOnNextJourney} disabled={journeyIndex === journeysSize - 1}>chevron_right</Button>
        </span>
  }
      actions={actions}
    />
  );
};

JourneyToolbar.propTypes = {
  intl: intlShape.isRequired,
  journey: PropTypes.object.isRequired,
  journeyIndex: PropTypes.number.isRequired,
  journeysSize: PropTypes.number.isRequired,
  handleOnHide: PropTypes.func.isRequired,
  handleClickOnPreviousJourney: PropTypes.func.isRequired,
  handleClickOnNextJourney: PropTypes.func.isRequired,
};

export default injectIntl(JourneyToolbar);



// WEBPACK FOOTER //
// ./src/components/Journey/JourneyToolbar.js